<template>
  <div class="PaticipantMenue">
    <!-- User Menue -->
    <md-list class="userMenue" :style="{bottom: bottom}">

      <!-- Go to User -->
      <md-list-item  @click="gotoSituation(); closeParticipantMenue();"> 
        <ArrowRightBoldHexagonOutline class="md-list-item-icon"/>
        <span class="md-list-item-text">{{ $t('Zu Raum des Teilnehmer gehen') }}</span>
      </md-list-item>

      <!-- Mute User -->
      <md-list-item @click="muteUser(); closeParticipantMenue();" v-if="isModerator()">
        <VolumeOff class="md-list-item-icon"/>
        <span class="md-list-item-text">{{ $t('Teilnehmer stummschalten') }}</span>
      </md-list-item>

      <!-- Stop Video of User -->
      <md-list-item @click="stopVideo(); closeParticipantMenue();" v-if="isModerator()">
        <VideoOff class="md-list-item-icon"/>
        <span class="md-list-item-text">{{ $t('Video des Teilnehmer ausstellen') }}</span>
      </md-list-item>

      <!-- Remove User from Session -->
      <md-list-item @click="removeUserFromSession(); closeParticipantMenue();" v-if="isModerator()">
        <AccountOff class="md-list-item-icon"/>
        <span class="md-list-item-text">{{ $t('Teilnehmer Entfernen') }}</span>
      </md-list-item>

    </md-list>
  </div>
</template>

<script>
import {mapGetters, mapState, mapMutations} from "vuex";
import VolumeOff from 'vue-material-design-icons/VolumeOff.vue'
import ArrowRightBoldHexagonOutline from 'vue-material-design-icons/ArrowRightBoldHexagonOutline.vue'
import AccountOff from 'vue-material-design-icons/AccountOff.vue'
import VideoOff from 'vue-material-design-icons/VideoOff.vue'

export default {
  components:{VolumeOff,ArrowRightBoldHexagonOutline,AccountOff,VideoOff},
  props: ['user','bottom'],
  inject: ["closeParticipantMenue"],
  methods:{
    ...mapMutations(["handleGotoSituationTransition"]),
    muteUser(){
      const signalData = {
        type: "mute",
        data: this.user.id,
      };
      this.session.signal(signalData, function (error) {
        if (error) {
          console.log(['signal error (', error.code, '): ', error.message].join(''));
        } else {
          console.log('mute signal sent');
        }
      });
    },
    stopVideo(){
      const signalData = {
        type: "stopVideo",
        data: this.user.id,
      };
      this.session.signal(signalData, function (error) {
        if (error) {
          console.log(['signal error (', error.code, '): ', error.message].join(''));
        } else {
          console.log('mute signal sent');
        }
      });
    },
    gotoSituation() {
      this.handleGotoSituationTransition({ situationID: this.user.currentSituationID } );
    },
    removeUserFromSession(){
      let connection = this.openTokStreams.filter( x => x.connection.data.user_id == this.user.id )[0].connection;
      console.log(connection);
      this.session.forceDisconnect(connection, function (error) {
        if (error) {
          console.log(error);
        } else {
          console.log("Connection forced to disconnect: " + connection.id);
        }
      });
    },
    isModerator(){
      return this.localUser.getRole() === 'moderator';
    },
  },
  computed:{
    ...mapGetters(["localUser"]),
    ...mapState({
      session: (state) => state.session.openTokSession,
      openTokStreams: (state) => state.session.openTokStreams,
    }),
  },
}
</script>

<style scoped>
.userMenue{
  position: absolute;
  width: 90%;
  background: white;
  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.2));
  z-index: 99;
}
.material-design-icon {
	height: 25px;
	width: 25px;
}
.material-design-icon > .material-design-icon__svg {
  fill: black;
  height: 25px;
	width: 25px;
}
.md-list-item-icon{
  margin-right: 10px;
}
.md-list-item-text{
  font-size: 14px;
}
</style>